module.exports = __webpack_public_path__ + "img/suit-04.da3b6fd9.png";